import { useFeatureFlag } from 'utils/hooks/useFeatureFlag';

export const useReactCampaignV1Feature = () => {
  return useFeatureFlag('CampaignReactificationV1', false);
};
